import React from "react";

const ColorbarContainer = ({ colorMinimized, toggleMinimizeColor }) => {
    return (
        <div className={`colorbar-panel ${colorMinimized ? "collapsed" : ""}`}>
            <button className="colorbar-collapse-btn" onClick={toggleMinimizeColor}>
                <svg width="6" height="10" viewBox="0 0 6 10" fill="currentColor">
                    {colorMinimized ? (
                        <path d="M0 0l6 5-6 5z"/>
                    ) : (
                        <path d="M6 0L0 5l6 5z"/>
                    )}
                </svg>
            </button>
            <div className="colorbar-inner" style={{ display: colorMinimized ? "none" : "flex" }}>
                <canvas id="colorbar" width="40" height="440"></canvas>
                <div id="color-tick-container"></div>
            </div>
        </div>
    );
};

export default ColorbarContainer;
